import { useEffect, useState, VoidFunctionComponent } from 'react';
import { ThreeEvent } from '@react-three/fiber';
import { Image } from '@react-three/drei';
import { useResponsive } from '@/hooks/useResponsive';
import check from '@/img/check.png';

const MARGIN = 0.075;

interface Props {
    url: string;
    index: number;
    selected: boolean;
    onClick: () => void;
}

export const CaptchaImage: VoidFunctionComponent<Props> = ({ url, index, onClick, selected }) => {
    const [hovered, setHovered] = useState<boolean>(false);

    const { responsiveValue } = useResponsive();

    const yPos = (-index % 3) * (1 + MARGIN);
    const xPos = Math.floor(index / 3) * (1 + MARGIN);

    const over = (e: ThreeEvent<PointerEvent>): void => {
        e.stopPropagation();
        setHovered(true);
    };
    const out = (): void => {
        setHovered(false);
    };
    useEffect(() => {
        if (hovered) {
            document.body.style.cursor = 'pointer';
        }
        return () => {
            document.body.style.cursor = 'auto';
        };
    }, [hovered]);

    return (
        <group scale={responsiveValue([1, 1, 1], [1.1, 1.1, 1])}>
            <group position={[responsiveValue(xPos, xPos - 0.15), yPos, 0]}>
                <Image
                    onPointerOver={over}
                    onPointerOut={out}
                    onClick={onClick}
                    url={url}
                    scale={selected ? 0.75 : 1}
                />
                {selected && <Image transparent url={check} position={[0.36, 0.36, 0]} scale={0.2} />}
            </group>
        </group>
    );
};
